//src/app/features/profile/businessDetails/editBusinessDetails/index.tsx
import {
  DashboardContainerHeader,
  ScrollContainer,
} from 'app/layout/dashboardLayout/BoxLayout';
import { BusinessProjectGetId } from 'app/services/responseTypes';
import {
  useGetUserBusinessByIdQuery,
  useUpdateBusinessProjectLogoMutation,
  useUpdateBusinessProjectMutation,
} from 'app/services/user';
import { SaveIcon } from 'assets/icons';
import Button from 'Components/Buttons/Button';
import { successToast } from 'Components/Notifications';
import Spinner from 'Components/Spinner';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BusinessForm } from '../BusinessForm';

export interface IEditBusinessDetailsProps {
  id?: number;
}

export default function EditBusinessDetails(props: IEditBusinessDetailsProps) {
  const { businessId: paramsId } = useParams();
  const id = !!props.id ? props.id.toString() : paramsId!;
  const { data } = useGetUserBusinessByIdQuery(id);

  const [UpdateBusinessProject, { isLoading }] =
    useUpdateBusinessProjectMutation();
  let navigate = useNavigate();

  const onSubmit = async (form: BusinessProjectGetId) => {
    const newBusinessOwnersIds = form.business_owners.map((bo) => bo.id);

    const deletedOwners = (data?.business.business_owners || [])
      .filter((bo) => !newBusinessOwnersIds.includes(bo.id))
      .map(({ id }) => ({ id, _destroy: true }));

    UpdateBusinessProject({
      id: id,
      business: {
        ...form,
        business_owners_attributes: [...form.business_owners, ...deletedOwners],
      },
    })
      .unwrap()
      .then(() => {
        successToast('Saved Successfully');
        navigate(-1);
      });
  };

  if (!data) return <Spinner />;
  return (
    <BusinessForm
      title={data?.business.name}
      isLoading={isLoading}
      button={
        <>
          Save <SaveIcon className="w-5 h-5" />
        </>
      }
      value={data.business}
      onSubmit={onSubmit}
    />
  );
}
